if (!customElements.get('cart-terms-3')) {
    class CartTerms extends HTMLElement {
      constructor() {
        super();
        this.innerHTML = `
          <div style="position: relative; display: inline-block; width: 100%;">
            <select id="note" name="note"
              style="border-radius: 0px;
                     color: #E1007D;
                     border: 2px solid #F20681;
                     font-size: 13px;
                     background-color: white;
                     outline: none;
                     appearance: none; /* Removes default browser arrow */
                     padding: 10px;
                     padding-right: 30px; /* Space for custom arrow */
                     cursor: pointer;
                     width: 100%;">
              <option value="Please select" selected>Please select</option>
              <option value="Remove the out-of-stock items and proceed to ship the remaining in-stock items. Refunds will be issued for the unavailable items.">Remove the out-of-stock items and proceed to ship the remaining in-stock items. Refunds will be issued for the unavailable items.</option>
              <option value="Cancel and refund the entire order.">Cancel and refund the entire order.</option>
              <option value="Contact me if items are out of stock via email.">Contact me if items are out of stock via email.</option>
            </select>
            <span style="content: '▼'; 
                        font-size: 12px; 
                        color: #E1007D; 
                        position: absolute; 
                        right: 10px; 
                        top: 50%; 
                        transform: translateY(-50%); 
                        pointer-events: none;">
              ▼
            </span>
          </div>
        `;        
        this.selectElement = this.querySelector('select');
        this.form = document.getElementById('cart');
        this.submitHandler = this.handleSubmit.bind(this);

        this.selectElement.addEventListener('change', () => {
          $.post('/cart/update.js', {
            note: this.selectElement.value
          }, function (data) {
            console.log('Note added');
          }, 'json');
        });
        
        this.form.addEventListener('submit', this.submitHandler);
      }

      disconnectedCallback() {
        this.form.removeEventListener('submit', this.submitHandler);
      }

      /**
       * Handles cart form submission
       * @param {object} evt - Event object.
       */
      handleSubmit(evt) {
        if (this.selectElement.value === 'Please select') {
          evt.preventDefault();
          // alert('You must select a valid processing method before continuing.');
          document.getElementById('error-message-3').style.display = 'block';
        } else {
          document.getElementById('error-message-3').style.display = 'none';
        }
      }
    }

    customElements.define('cart-terms-3', CartTerms);
  }